<template>
    <div id="adminDetail" class="app-inner">
         <div class="public-btn-small flex align-cen" style="padding-left:0;margin-bottom:16px">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
            </div>
             <div class="edit-from" v-if="$route.query.type == 1">
                    <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
                     <div class="p-tit-c" style="margin:16px 0">
                 <div class="businessDetail-info flex align-cen">
                     <div class="list">
                    管理员姓名：{{infoList.userName}}
                </div>
                    <div class="list" style="margin-left:200px">
                    管理员账号：{{infoList.loginName}}
                </div>
                 </div>
             </div>
            <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  绑定企业信息
            </div>
        </div>
     <div class="businessDetail-data-table">
               <el-table
            :data="infoList.platformBusinessList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column
            prop="id"
            label="企业ID"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="name"
            label="企业名称"
           align="center"
            >
            </el-table-column>
            <el-table-column
            prop="classifyName"
            label="企业类型"
           align="center"
            >
            </el-table-column>
               <el-table-column label="企业电话" align="center">
            <template slot-scope="scope">
              <div
                class="flex align-cen justify-content-cen"
                style="width: 100%"
              >
                <div v-if="scope.row.showPhone">
                  {{ $util.getRegular(scope.row.phone) }}
                </div>
                <div v-else>{{ scope.row.phone }}</div>
                <el-button
                  type="text"
                  @click="see(scope)"
                  style="padding-left: 10px"
                  >查看</el-button
                >
              </div>
            </template>
          </el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center">
          </el-table-column>
          <el-table-column label="企业状态" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.state == 0
                  ? "试用"
                  : scope.row.state == 1
                  ? "有意向"
                  : scope.row.state == 2
                  ? "谈判"
                  : scope.row.state == 3
                  ? "合作中"
                  : "停止合作"
              }}</span>
            </template>
          </el-table-column>
        </el-table>
         </div>
               <div class="public-tit flex align-cen" style="margin:16px 0">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  绑定微信
            </div>
        </div>
         <div class="businessDetail-data-table">
             <el-table
            :data="wechatArr"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column prop="" label="微信号" align="center">
          </el-table-column>
           <el-table-column prop="" label="微信昵称" align="center">
          </el-table-column>
           <el-table-column prop="" label="微信头像" align="center">
          </el-table-column>
           <el-table-column prop="" label="操作" align="center">
          </el-table-column>
             </el-table>
         </div>
             </div>
             <div class="edit-from" v-if="$route.query.type == 2 || $route.query.type == 3">
                          <div class="p-tit-c">
 <div class="businessDetail-info flex align-cen">
    <div class="businessDetail-info-logo">
        <img :src="infoList.avatar ? infoList.avatar : require('../../../assets/images/blogo.png')" alt="">
    </div>
    <div class="businessDetail-info-con flex">
       <div class="list">
        用户ID：{{infoList.id}}
       </div>
         <div class="list">
        账号昵称：{{infoList.userName}}
       </div>
         <div class="list">
        注册时间：{{infoList.createTime}}
       </div>
         <div class="list flex">
        注册渠道：<span class="maxwid">{{infoList.channel}}</span>
       </div>
        <div class="list">
        用户微信号：{{infoList.wechatAccount || '暂无'}}
       </div>
        <div class="list">
        最后登录：{{infoList.loginTime}}
       </div>
    </div>
 </div>
 </div>
      <div class="public-tit flex align-cen" style="margin:16px 0">
            <div class="public-tit-list">
                <i class="icon-al-user-fill"></i>  账户信息
            </div>
        </div>
         <div class="businessDetail-data-table">
             <el-table
            :data="userinfo"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column prop="score" label="可用积分" align="center">
          </el-table-column>
           <el-table-column label="优惠券（张）" align="center">
          <template>
            暂无
          </template>
          </el-table-column>
           <el-table-column prop="loginNum" label="登录次数" align="center">
          </el-table-column>
             </el-table>
         </div>
          <div class="public-tit flex align-cen" style="margin:16px 0">
            <div class="public-tit-list">
                <i class="icon-al-qiyeguanli"></i>  所属企业
            </div>
        </div>
               <div class="businessDetail-data-table">
               <el-table
            :data="infoList.platformBusinessList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column
            prop="id"
            label="企业ID"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="name"
            label="企业名称"
           align="center"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="是否为企业管理员" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.isAdmin == 0
                  ? "否"
                  : "是"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
               <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="detail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
         </div>
            </div>
    </div>
</template>
<script>
import { businessAccountDetail } from "@/api/index/index" //详情
export default {
    name:'adminDetail',
    data: () =>{
        return {
            infoList:{
            },
            newArry:[],
            wechatArr:[],
            userinfo:[]
        }
    },
    created(){
        this.getDetail()
        // this.$route.query.type==1表示企业管理员、2表示注册用户
    },
    methods: {
        // 打开企业详情
        detail(data){
            this.$router.push({
            name: "businessDetail",
            query:{
                id:data.id,
                type:this.$route.query.type,
                redicetId:this.$route.query.id,
                 str:'userCure'
            }
           })
        },
      // 查看手机号
        see(data){
          data.row.showPhone = false
        },
                 // 获取详情
        getDetail(){
          this.userinfo = []
              businessAccountDetail({
                id:this.$route.query.id
              })
            .then(res => {
                this.infoList = res.data
                  this.userinfo = [
                    {
                        score:res.data.score,
                        loginNum:res.data.loginNum
                    }
                ]
                 for (const i in  res.data.platformBusinessList) {
                this.$set(this.infoList.platformBusinessList[i], 'showPhone', true)
              }
            })
            .catch(err => {
            })
        },
        reback(){
            this.$route.query.type == 1 ? this.$router.push('/businessAdmin') : this.$route.query.type == 2 ? this.$router.push('/User') : this.$router.push('/UserClue')
        }
    }
}
</script>
<style lang="scss" scoped>
#adminDetail{
    height: inherit;
    .businessDetail-data-table{
        margin-top: 20px;
    }
      .businessDetail-info{
        padding: 30px 20px 20px 20px; 
        .businessDetail-info-logo{
            width: 200px;
            border-right: 1px solid #ccc;
            img{
                width: 100px;
                height: 100px;
                border-radius: 100px;
                margin: 0 auto;
                display: block;
            }
        }
        .businessDetail-info-con{
            width: calc(100% - 200px);
            padding: 0 20px;
            flex-wrap: wrap;
            .list{
                width: 33%;
                padding-bottom: 20px;
            }
        }
    }
}
@media (max-width: 1380px){
.maxwid{
width: 120px;
}
}

</style>
